<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dataVariacao"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        solo
        class="textinput"
        :placeholder="placeholderData"
        :color="$config.dados.corinputs"
        clearable
        @click:clear="
          $relatorios_sinteticos.clearFilterFields('canal_venda_dates')
        "
      >
        <template bottom slot="append-outer">
          <v-btn icon @click="remove">
            <v-icon color="grey darken-2" small> mdi-trash-can </v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="descricao"
      :active-picker.sync="activePicker"
      locale="pt"
      :header-color="$config.dados.corinputs"
      :color="$config.dados.corinputs"
      :max="
        $produtos_gerenciar.cadastro.periodo_vendas.data_termino !== null &&
        $produtos_gerenciar.cadastro.periodo_vendas.data_termino !== ''
          ? $config.convertDataEN(
              $produtos_gerenciar.cadastro.periodo_vendas.data_termino.substring(
                0,
                10
              )
            )
          : new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
      "
      :min="
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      "
      @change="save"
    >
    </v-date-picker>
  </v-menu>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "opcao-data",
  props: {
    descricaoOpcao: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dayjs: dayjs,
      activePicker: null,
      date: null,
      menu: false,
      dataVariacao: "",
      placeholderData: "dd/mm/aa",
    };
  },
  computed: {
    descricao: {
      get() {
        return this.descricaoOpcao;
      },
      set(value) {
        this.$emit("inputValue", value);
      },
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "DATE"));
    },
  },
  methods: {
    remove() {
      this.$emit("remove");
    },
    save(date) {
      this.$refs.menu.save(date);
      this.dataVariacao = this.$config.convertDataBR(date);
    },
  },
  mounted() {
    this.dataVariacao = this.$config.convertDataBR(this.descricaoOpcao);
  },
};
</script>
<style scoped>
.produtos-gerenciar-textinput {
  width: 100%;
  height: 51px;
  border-radius: 0.625rem;
}

.produtos-trash-variacoes-icon {
  width: 26px;
  height: 26px;
  fill: #666 !important;
  transition: all 0.2s ease;
}

.produtos-trash-variacoes-icon:hover {
  fill: #fff !important;
  cursor: pointer;
}
</style>
